/**
 * Prevents the app from being embedded in a foreign iframe (clickjacking mitigation).
 * Loaded from main.ts instead of an inline script in index.html for CSP compliance.
 */
export function initFrameBuster(): void {
  if (globalThis.top !== globalThis.self) {
    globalThis.top!.location.href = globalThis.location.href;
  }
}
